import React, { useState } from 'react';

import { useMutation } from '@sopranodesign/pulse-hooks';
import { Flex, Button, useNotification } from '@sopranodesign/pulse-components';
import { ConditionalProvider } from '@sopranodesign/pulse-conditionals';
import { PermissionFilter } from '@sopranodesign/pulse-auth';

import { conditionals } from '../../../subjects/index';
import { updateConversation } from '../api/index';
import { useBuilder } from '../hooks/index';
import ConversationDetails from '../../../Components/ConversationDetails';
import Modal from './Modal';

const EditConversation = () => {
  const [showEdit, setShowEdit] = useState(false);

  const { conversation, dispatch } = useBuilder();

  const { showSuccess } = useNotification();

  const mutation = useMutation({
    mutationFn: updateConversation,
    onSuccess: ({ data }) => {
      dispatch({ type: 'UPDATE_CONVERSATION', conversationDetails: data.data });
      showSuccess('Successfully updated your conversation');
      setShowEdit(false);
    }
  });

  const handleSubmit = details => {
    mutation.mutate({ id: conversation.id, conversation: details });
  };

  const handleClose = () => {
    setShowEdit(false);
  };

  return (
    <>
      {showEdit && (
        <Modal header="Edit conversation" handleClose={handleClose}>
          <Flex col pad="true">
            <ConditionalProvider subjects={conditionals}>
              <ConversationDetails
                handleSubmit={handleSubmit}
                initialTitle={conversation.title}
                initialDescription={conversation.description}
                initialGroups={conversation.groups.map(group => group.id)}
                showConditional={false}
                loading={mutation.isPending}
              />
            </ConditionalProvider>
          </Flex>
        </Modal>
      )}
      <PermissionFilter can="edit conversations">
        <Button
          aria-label="Edit conversation"
          icon="pencilAlt"
          onClick={() => setShowEdit(true)}
          variant="secondary"
        />
      </PermissionFilter>
    </>
  );
};

export default EditConversation;
